import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "antd";
import { useLocation, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";

import {
  UpdateReportsDownload,
  handleloading,
} from "../../../Store/Redux/Reducers/Dashboardreducers";
import { ReportsListData } from "../../../Services/ApiServices";
import {
  CatchMessage,
  FilterValuesCheck,
  HandleDeviceId,
  HandleMeterId,
  JSONtoformdata,
  downloadUrl,
  tokenisValid,
} from "../../../Shared/Methods";
import { HandleSessionModal } from "../../../Store/Redux/Reducers/Authreducers";
import { getDisplayCount } from "../../../Components/Tables/DisplayTableDataCount";
import classes from "../HomeScreen.module.css";
import Loader from "../../../SharedComponents/Loader/Loader";
import Commontooltip from "../../../Components/CommonTooltip/Commontooltip";
import alerticon from "../../../Assests/Icons/warning.png";
import Filterreadingreport from "../../../Components/Filters/Reports/FilterReadingReport";
import ReadingReportsTable from "../../../Components/Tables/Reports/ReadingReportsTable";
import Newcommontable from "../../../Components/Tables/NewCommonTable";
import Commonpagination from "../../../Components/Tables/CommonPagination";
import dayjs from "dayjs";

function Readingreport({ value }: any) {
  const dispatch = useDispatch();
  const { reportsFilterData, loading } = useSelector(
    (state: any) => state.Dashboard
  );
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [deviceList, setDeviceList] = useState<any>([]);
  const [Values, setValues] = useState({ from_date: "", to_date: "" });
  const [pageSize, setpageSize] = useState(30);
  const [pageind, setPageInd] = useState(0);
  // const [showAlerModal, setshowAlerModal] = useState<any>({
  //   isView: false,
  //   item: "",
  // });
  const [isTime, setIsTime] = useState<boolean>(false);
  const { showfilter, isDownload, setIsDownload, setShowFilter } =
    useOutletContext<{
      showfilter: boolean;
      isDownload: boolean;
      setIsDownload: Dispatch<SetStateAction<boolean>>;
      setShowFilter: Dispatch<SetStateAction<boolean>>;
    }>();
  const [isChecked, setIsChecked] = useState<any>({
    // isEbchecked: false,
    // isDgchecked: false,

    pin_1_status: false,
    pin_2_status: false,
    pin_3_status: false,
  });
  const [CheckedArray, SetCheckedArray] = useState<any>([]);
  const [isAlert, setIsAlert] = useState(false);
  const [AlphabetType, setAlphabetTyppe] = useState<{
    OrderBy: string;
    Order: string;
  }>({ OrderBy: "", Order: "" });
  const renderondeviceID = HandleDeviceId();
  const renderonmeterID = HandleMeterId();
  const location = useLocation();
  const { state } = location || {};
  // const { communicationfail, currentdate } = state || {};
  const { communicationfail, currentdate } = reportsFilterData;
  const [CommunicationFailValue, setCommunicationFailValue] =
    useState<boolean>(false);

  const ChangeOrderType = (OrderBy: string, Order: string) => {
    setAlphabetTyppe({ OrderBy: OrderBy, Order: Order });
  };

  useEffect(() => {
    if (
      LoginData !== null &&
      renderondeviceID?.deviceId &&
      renderonmeterID?.meter_id
    ) {
      handleReportsViewList(
        1,
        30,
        Values,
        false,
        false,
        AlphabetType?.OrderBy,
        AlphabetType?.Order,
        isChecked?.pin_1_status,
        isChecked?.pin_2_status,
        isChecked?.pin_3_status,
        isAlert,
        isTime,
        // communicationfail ? true : false
        CommunicationFailValue || communicationfail ? true : false
      );

      if (currentdate && communicationfail) {
        setShowFilter(true);
        setCommunicationFailValue(true);
      } else {
        setShowFilter(false);
      }
    }
  }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id]);

  useEffect(() => {
    if (isDownload) {
      handleReportsViewList(1, 30, Values, false, true);
    }
  }, [isDownload]);

  const ResetForm = () => {
    handleReportsViewList(
      1,
      pageSize,
      value,
      true,
      false,
      AlphabetType?.OrderBy,
      AlphabetType?.Order,
      // isChecked?.isEbchecked,
      // isChecked?.isDgchecked,

      isChecked?.pin_1_status,
      isChecked?.pin_2_status,
      isChecked?.pin_3_status,

      isAlert,
      isTime,
      CommunicationFailValue
    );
    setValues({ from_date: "", to_date: "" });
    setIsTime(false);
  };

  const handleReportsViewList = (
    page = 1,
    size = 30,
    filterData?: any,
    isreset = false,
    isDownload = false,
    OrderBy = "",
    Order = "",
    // eb_power = false,
    pin_1_status = false,
    // dg_power = false,
    pin_2_status = false,
    pin_3_status = false,
    isAlert = false,
    withTime = false,
    communicationfailvalue = false
  ) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      withTime: withTime ? 1 : "",
      order_by: OrderBy,
      order: Order,
      // eb_power: eb_power ? 1 : "",
      pin_1_status: pin_1_status ? 1 : "",
      // dg_power: dg_power ? 1 : "",
      pin_2_status: pin_2_status ? 1 : "",
      pin_3_status: pin_3_status ? 1 : "",
      isAlert: isAlert ? 1 : "",
      isDownload: isDownload ? 1 : 0,
      ...renderondeviceID,
      ...renderonmeterID,
      communication_fail: communicationfailvalue ? 1 : "",
    };

    const WithValues =
      currentdate && !isreset && FilterValuesCheck(filterData ? filterData : {})
        ? Object.assign(finalObj, {
            from_date: dayjs(currentdate).format("YYYY-MM-DD 23:59:59"),
          })
        : !isreset
        ? Object.assign(finalObj, filterData ? filterData : Values)
        : finalObj;

    ReportsListData(
      JSONtoformdata(WithValues),
      page,
      size,
      "report/data_report"
    )
      .then(async (res) => {
        if (res.data.status === 1) {
          if (isDownload) {
            downloadUrl(res?.data?.data || "");
            // setIsDownload(false);
            return;
          }
          setDeviceList(res.data.data);
          if (filterData && !isreset) {
            setValues(filterData);
          }
          setPageInd(page > 1 ? page - 1 : 0);
          dispatch(
            UpdateReportsDownload(
              res?.data?.data?.total_count === 0 ? false : true
            )
          );
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
        if (isDownload) {
          setIsDownload(false);
        }
      });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    handleReportsViewList(
      1,
      30,
      Values,
      false,
      false,
      AlphabetType?.OrderBy,
      AlphabetType?.Order,
      // isChecked?.isEbchecked,
      // isChecked?.isDgchecked,

      isChecked?.pin_1_status,
      isChecked?.pin_2_status,
      isChecked?.pin_3_status,

      isAlert,
      isTime,
      CommunicationFailValue
    );
    if (setIsChecked && SetCheckedArray && setIsAlert) {
      setIsChecked(isChecked);
      SetCheckedArray(CheckedArray);
      setIsAlert(isAlert);
      setAlphabetTyppe(AlphabetType);
    }
  };

  const {
    items,
    page,
    size,
    total_page,
    total_count,
    total_consumption,
    today_cunsumption,
  } = deviceList;

  return (
    <>
      <Loader isLoader={loading} />

      {/* <Modal show={showAlerModal?.isView} size="lg">
        <ReportAllertModal
          close={() => setshowAlerModal({ isView: false, item: "" })}
          item={showAlerModal?.item}
        />
      </Modal> */}

      <div className={classes.table_container_background}>
        <Filterreadingreport
          showfilter={showfilter}
          pageSize={pageSize}
          pageind={pageind}
          GetList={handleReportsViewList}
          setpageSize={setpageSize}
          setPageInd={setPageInd}
          ResetForm={ResetForm}
          setIsTime={setIsTime}
          isTime={isTime}
          setIsChecked={setIsChecked}
          SetCheckedArray={SetCheckedArray}
          setIsAlert={setIsAlert}
          isChecked={isChecked}
          CheckedArray={CheckedArray}
          isAlert={isAlert}
          AlphabetType={AlphabetType}
          setAlphabetTyppe={setAlphabetTyppe}
          currentdate={currentdate}
          communicationfailvalue={CommunicationFailValue}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          id="readingreportsalertcheckbox"
        >
          {getDisplayCount(deviceList?.page, pageSize, deviceList?.total_count)}

          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <Commontooltip
              children={
                <div style={{ display: "flex" }}>
                  <img
                    src={alerticon}
                    style={{ height: 30, marginRight: "2px" }}
                    alt="alerticon"
                  />

                  <div
                    style={{
                      border: "1px solid black",
                      padding: "2px 10px",
                      borderRadius: "4px",
                    }}
                  >
                    <Checkbox
                      checked={isAlert}
                      onClick={() => {
                        setIsAlert(!isAlert);
                        handleReportsViewList(
                          1,
                          30,
                          Values,
                          false,
                          false,
                          AlphabetType?.OrderBy,
                          AlphabetType?.Order,
                          // isChecked?.isEbchecked,
                          // isChecked?.isDgchecked,

                          isChecked?.pin_1_status,
                          isChecked?.pin_2_status,
                          isChecked?.pin_3_status,

                          !isAlert ? true : false,
                          isTime,
                          CommunicationFailValue
                        );
                        setAlphabetTyppe(AlphabetType);
                      }}
                    >
                      <strong style={{ color: "#274c5e", fontSize: "15px" }}>
                        Is Alert
                      </strong>
                    </Checkbox>
                  </div>
                </div>
              }
              msg="Click to filter PF,LV and HV Alerts"
            />

            <Commontooltip
              children={
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      border: "1px solid black",
                      padding: "2px 10px",
                      borderRadius: "4px",
                    }}
                  >
                    <Checkbox
                      checked={CommunicationFailValue}
                      onClick={() => {
                        handleReportsViewList(
                          1,
                          30,
                          Values,
                          false,
                          false,
                          AlphabetType?.OrderBy,
                          AlphabetType?.Order,
                          // isChecked?.isEbchecked,
                          // isChecked?.isDgchecked,

                          isChecked?.pin_1_status,
                          isChecked?.pin_2_status,
                          isChecked?.pin_3_status,

                          isAlert,
                          isTime,
                          !CommunicationFailValue ? true : false
                        );
                        setCommunicationFailValue(!CommunicationFailValue);
                      }}
                    >
                      <strong style={{ color: "#274c5e", fontSize: "15px" }}>
                        Read Error
                      </strong>
                    </Checkbox>
                  </div>
                </div>
              }
              msg="Click to Read Error"
            />
          </div>

          {/* <CommonButton
            name={!isAlert ? "Filter Alerts" : "Reset"}
            type="button"
            style={{ bgcolor: "#e97f02" }}
          /> */}
        </div>

        {/* temporarily not used */}

        {/* <Reportstable
          deviceList={deviceList}
          pageSize={pageSize}
          pageind={pageind}
          GetList={handleReportsViewList}
          setpageSize={setpageSize}
          setPageInd={setPageInd}
          columns={columns}
          // setshowAlerModal={setshowAlerModal}
          defaultPageSize={30}
          PageSizeOptions={[30]}
          setIsChecked={setIsChecked}
          SetCheckedArray={SetCheckedArray}
          setIsAlert={setIsAlert}
          isChecked={isChecked}
          CheckedArray={CheckedArray}
          isAlert={isAlert}
          AlphabetType={AlphabetType}
          setAlphabetTyppe={setAlphabetTyppe}
          isTime={isTime}
        /> */}

        <Newcommontable
          Children={
            <ReadingReportsTable
              deviceList={deviceList}
              pageSize={pageSize}
              pageind={pageind}
              GetList={handleReportsViewList}
              setIsChecked={setIsChecked}
              SetCheckedArray={SetCheckedArray}
              isChecked={isChecked}
              CheckedArray={CheckedArray}
              isAlert={isAlert}
              AlphabetType={AlphabetType}
              isTime={isTime}
              communicationfailvalue={CommunicationFailValue}
              Values={Values}
              ChangeOrderType={ChangeOrderType}
              OBJKeys={[
                "created_at",
                // "eb_power",
                "pin_1_status",
                // "dg_power",
                "pin_2_status",
                "pin_3_status",
                // "sump_status",
                "wh_received",
                "wh_consumed",
                "pf_alert",
                "lv_alert",
                "hv_alert",

                "watts_total",
                "watts_r_phase",
                "watts_y_phase",
                "watts_b_phase",

                "va_total",
                "va_r_phase",
                "va_y_phase",
                "va_b_phase",

                "v_ln_avg",
                "v_r_phase",
                "v_y_phase",
                "v_b_phase",

                "v_ll_avg",
                "v_br_phase",
                "v_ry_phase",
                "v_yb_phase",

                "i_avg",
                "i_r_phase",
                "i_y_phase",
                "i_b_phase",

                "PF_avg",
                "PF_r_phase",
                "PF_y_phase",
                "PF_b_phase",
                "failure_duration",
              ]}
            />
          }
        />

        <Commonpagination
          onShowSizeChange={Changesize} ///call when page size click
          PageSizeOptions={[30]}
          defaultPageSize={30}
          total={total_count}
          pageSize={size}
          current={page}
          onChange={(e, size) => {
            ///call when page number click

            // if (size === pageSize) {

            handleReportsViewList(
              e,
              size,
              Values,
              false,
              false,
              AlphabetType?.OrderBy,
              AlphabetType?.Order,
              // isChecked?.isEbchecked,
              // isChecked?.isDgchecked,

              isChecked?.pin_1_status,
              isChecked?.pin_2_status,
              isChecked?.pin_3_status,

              isAlert,
              isTime,
              CommunicationFailValue
            );
            if (setIsChecked && SetCheckedArray && setIsAlert) {
              setIsChecked(isChecked);
              SetCheckedArray(CheckedArray);
              setIsAlert(isAlert);
              setAlphabetTyppe(AlphabetType);
            }
            // }
          }}
        />
      </div>
    </>
  );
}

export default Readingreport;
